// extracted by mini-css-extract-plugin
export default {"container":"toto_container__gRc6j","child-container":"toto_child-container__0apgb","footer":"toto_footer__uhNle","copy":"toto_copy__0QI6C"};